import { render, staticRenderFns } from "./UserSearch.vue?vue&type=template&id=12c96670&scoped=true&"
import script from "./UserSearch.vue?vue&type=script&lang=js&"
export * from "./UserSearch.vue?vue&type=script&lang=js&"
import style0 from "./UserSearch.vue?vue&type=style&index=0&id=12c96670&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c96670",
  null
  
)

export default component.exports